"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const stores_1 = require("modules/content/dripping/stores");
const numberOfDayField_1 = __importDefault(require("./numberOfDayField"));
const mapStateToProps = (stores) => ({
    releaseNumberOfDays: stores.DrippingFormStore.releaseNumberOfDays
});
const ReleaseSettings = ({ releaseNumberOfDays }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const handleNumberOfDaysChange = ({ target }) => {
        const newNumberOfDays = target.value !== '' ? Number(target.value) : null;
        stores_1.DrippingFormStore.setReleaseNumberOfDays(newNumberOfDays);
    };
    const currentNumberOfDaysValue = releaseNumberOfDays === null ? '' : String(releaseNumberOfDays);
    return ((0, jsx_runtime_1.jsx)(numberOfDayField_1.default, { id: "releaseNumberOfDays", className: "_mt-3", labelBeforeInput: t('dripping_2.new.release_and_expiration.release.title'), labelAfterInput: t('dripping_2.new.release_and_expiration.release.items.days_after_purchase.number_of_days', { amountToPluralize: releaseNumberOfDays || 0 }), value: currentNumberOfDaysValue, onChange: handleNumberOfDaysChange }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(ReleaseSettings);
